import { create } from "zustand";
import { api } from "./api";

interface Me { id: string; email: string }
interface AuthState {
  user: Me | null;
  loading: boolean;
  refresh: () => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  signup: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  loading: true,
  refresh: async () => {
    // 401 here is the expected state for an anonymous visitor — we suppress the
    // console.warn that fetch() emits for failed requests by reading the body
    // first (so the browser doesn't surface an "uncaught (in promise)" line).
    try {
      const r = await api.me();
      set({ user: { id: r.user.id, email: r.user.email }, loading: false });
    } catch {
      set({ user: null, loading: false });
    }
  },
  login: async (email, password) => {
    const r = await api.login(email, password);
    set({ user: { id: r.user.id, email: r.user.email } });
  },
  signup: async (email, password) => {
    const r = await api.signup(email, password);
    set({ user: { id: r.user.id, email: r.user.email } });
  },
  logout: async () => {
    await api.logout();
    set({ user: null });
  },
}));
